import { render, staticRenderFns } from "./TypeValidationForm.vue?vue&type=template&id=80de9a12&scoped=true&"
import script from "./TypeValidationForm.vue?vue&type=script&lang=js&"
export * from "./TypeValidationForm.vue?vue&type=script&lang=js&"
import style0 from "./TypeValidationForm.vue?vue&type=style&index=0&id=80de9a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80de9a12",
  null
  
)

component.options.__file = "TypeValidationForm.vue"
export default component.exports